import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { deliveryId, uniqueID } from '../../utils/constants';
import { authHeaders, axiosInstance, encodeValue } from '../../utils/helper';
import qs from 'qs';

const initialState = {
	outlet_id: null,
	product: [],
	outlet: null,
	cart: null,
	cartItem: null,
	item: null,
	notes: null,
	loading: false,
	simple: null,
	combo: null,
	delivery: null,
	pathnersList: [],

	isLoadingRemoveCart: false,
};

export const handleGetCartDetail = createAsyncThunk('outlet/handleGetCart', async ({ customerID, companyID, storeID, availabilityID = deliveryId }) => {
	let url = `cart/loadCartDetails?unquieid=${uniqueID}}&availabilityID=${availabilityID}&storeID=${storeID}`;

  if (customerID) {
    url += `&customerID=${customerID}`;
  }

  if (companyID) {
    url += `&company_id=${companyID}`;
  }

	const res = await axiosInstance.get(url, authHeaders());
	const data = await res.data;
	return data;
});

export const removeCart = createAsyncThunk('outlet/handleRemoveCart', async () => {
	const postData = {
		unquieid: uniqueID,
	};

	const res = await axiosInstance.post(`cart/removeCart`, qs.stringify(postData), authHeaders());
	const data = await res.data;
	return data;
});

const cart = createSlice({
	name: 'cart',
	initialState,
	reducers: {
		setCart: (state, action) => {
			return { ...state, ...action.payload };
		},
		clearCart: () => {
			return initialState;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(handleGetCartDetail.pending, (state) => {
				state.loading = true;
			})
			.addCase(handleGetCartDetail.fulfilled, (state, action) => {
				state.loading = false;
				state.cart = action.payload.result || [];
			})
			.addCase(handleGetCartDetail.rejected, (state) => {
				state.loading = false;
			})
			.addCase(removeCart.pending, (state) => {
				state.isLoadingRemoveCart = true;
			})
			.addCase(removeCart.fulfilled, (state) => {
				state.isLoadingRemoveCart = false;
			})
			.addCase(removeCart.rejected, (state) => {
				state.isLoadingRemoveCart = false;
			});
	},
});

// Export actions and reducer
export const { setCart, clearCart } = cart.actions;
export default cart.reducer;
